export default {"src":"/_next/static/media/home.c2378836.svg","height":611,"width":692};